export const Forms = (() => {
	'use strict';

	function init() {
		var $forms = $('.gform_wrapper form');
		$forms.each( function() {
			var $fp = $('<div class="focal-point"></div>');
			$(this).append($fp);
			var $inputs = $(this).find(':input');
			$inputs.on('focus', function() {
				var top = $(this).position().top;
				var half_height = $(this).outerHeight() / 2;
				$fp.css('transform', 'translateY('+ (top + half_height)+'px)');
			});

			// init
			var first_input_top = $inputs.eq(0).position().top;
			var first_input_half_height = $inputs.eq(0).outerHeight() / 2;
			$fp.css('transform', 'translateY('+ (first_input_top + first_input_half_height)+'px)');

		});
	}

	return {
		init: init
	};
})();
